import React from 'react'
import { Container } from '@quotatisgroup/uikit-public.ui.container'
import { Footer } from '@quotatisgroup/uikit-public.ui.footer'
import { Row } from '@quotatisgroup/uikit-public.ui.row'
import { Col } from '@quotatisgroup/uikit-public.ui.col'
import { Image } from '@quotatisgroup/uikit-public.ui.image'
import { Icon } from '@quotatisgroup/uikit-public.ui.icon'
import { Text } from '@quotatisgroup/uikit-public.ui.text'
import UniverseLink from 'components/UniverseLink/UniverseLinkContainer'
import cloudinary from 'utils/cloudinary'
import injectTranslate from 'i18n/hoc/injectTranslate'
import PropTypes from 'prop-types'
import { useMediaQuery } from 'react-responsive'
import { UNIVERSES } from 'constants/routes'

const MOBILE_WIDTH_BREAKPOINT = 768

const FooterSection = ({ translate }) => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${MOBILE_WIDTH_BREAKPOINT}px)`,
  })

  const partnersPart = (
    <Col sm="12" md="3" padding="top-md" mdPadding="horizontal-sm">
      <Text color="secondary">{translate('footer.title.partners')}</Text>
      <Text color="grey">{translate('footer.text.solution')}</Text>
      <UniverseLink
        id="email-friends-link"
        href={translate('homepage.block7.sub2.url')}
        isBlock
        color="white"
        icon="email"
        iconSize="sm"
        iconPosition="left"
        margin="bottom-sm"
      >
        {translate('footer.link.email-friends')}
      </UniverseLink>
    </Col>
  )

  const proPart = (
    <Col
      sm="12"
      md="3"
      margin="top-lg"
      mdMargin="null"
      padding="null"
      mdPadding="left-sm"
    >
      <Text color="secondary">{translate('footer.title.pro')}</Text>
      <Text color="grey">{translate('footer.text.win-more')}</Text>
      <UniverseLink
        id="know-more-link"
        universe={UNIVERSES.PRO}
        isBlock
        color="white"
        icon="info"
        iconSize="sm"
        iconPosition="left"
        margin="bottom-sm"
        to="/"
      >
        {translate('footer.link.know-more')}
      </UniverseLink>
      <UniverseLink
        id="footer-faq-link"
        href="https://lecoindespros.quotatis.fr/help-center/"
        isBlock
        color="white"
        icon="faq"
        iconSize="sm"
        iconPosition="left"
        margin="bottom-sm"
      >
        {translate('access.link.help')}
      </UniverseLink>
      <UniverseLink
        id="email-service-link"
        href="mailto:service-forfaits@quotatis.com"
        isBlock
        color="white"
        icon="email"
        iconSize="sm"
        iconPosition="left"
        margin="bottom-sm"
      >
        {translate('footer.link.email-service')}
      </UniverseLink>
      <UniverseLink
        id="number-phone-link"
        href={translate('footer.link.number-phone-href')}
        isBlock
        color="white"
        icon="phone"
        iconSize="sm"
        iconPosition="left"
        margin="bottom-sm"
      >
        {translate('footer.link.number-phone')}
      </UniverseLink>
    </Col>
  )

  const linkPart = (
    <Col
      sm="12"
      md="3"
      padding="top-md"
      mdPadding="horizontal-sm"
      align={isMobile ? 'sm-right' : 'sm-center'}
    >
      <Text>
        <UniverseLink
          id="footer-about-us-link"
          universe={UNIVERSES.PRO}
          path="/qui-sommes-nous/"
          isBlock
          isBold
          color="basic"
          margin="vertical-sm"
        >
          {translate('footer.link.about-us')}
        </UniverseLink>
      </Text>
      <Text>
        <UniverseLink
          id="footer.adeo-link"
          href="https://www.adeo.com/"
          isBlock
          isBold
          color="basic"
          mdMargin="bottom-sm"
        >
          {translate('footer.link.adeo')}
        </UniverseLink>
      </Text>
    </Col>
  )

  const logoPart = (
    <Col
      sm="12"
      md="3"
      padding="vertical-md"
      mdPadding="right-sm"
      align={isMobile ? 'md-right' : 'md-center'}
    >
      <UniverseLink id="footer-logo-link" href="https://www.quotatis.fr">
        <Image
          src={cloudinary('/vitrine/logo/logo_light.svg')}
          alt={translate('alt.footer.home')}
          size="sm"
        />
      </UniverseLink>
      <Text>{translate('footer.title.works')}</Text>
    </Col>
  )

  const socialPart = (
    <Col md="12" margin="right-md" mdMargin="null">
      <UniverseLink
        id="footer-instagram-link"
        href="https://www.instagram.com/quotatis/"
        target="_blank"
      >
        <Icon
          name="instagram"
          color="white"
          size="md"
          alt={translate('alt.footer.home')}
          margin="right-sm"
        />
      </UniverseLink>
      <UniverseLink
        id="footer-facebook-link"
        href="https://www.facebook.com/Quotatis.FR"
        target="_blank"
      >
        <Icon
          name="facebook-fill"
          color="white"
          size="md"
          alt={translate('alt.footer.home')}
          margin="right-sm"
        />
      </UniverseLink>
      <UniverseLink
        id="footer-linkedin-link"
        href="https://www.linkedin.com/company/quotatis/"
        target="_blank"
      >
        <Icon
          name="linkedin-fill"
          color="white"
          size="md"
          alt={translate('alt.footer.home')}
          margin="right-sm"
        />
      </UniverseLink>
      <UniverseLink
        id="footer-youtube-link"
        href="https://www.youtube.com/channel/UCK9Cb_eScGl8dqs_zn35V4A"
        target="_blank"
      >
        <Icon
          name="youtube"
          color="white"
          size="md"
          alt={translate('alt.footer.home')}
          margin="right-sm"
        />
      </UniverseLink>
    </Col>
  )

  return (
    <Footer>
      <Container>
        <Row padding="horizontal-sm" mdPadding="top-lg">
          {isMobile ? (
            <>
              {proPart}
              {partnersPart}
              {linkPart}
              {logoPart}
              {socialPart}
            </>
          ) : (
            <>
              {logoPart}
              {linkPart}
              {partnersPart}
              {proPart}
              {socialPart}
            </>
          )}
        </Row>
        <Row padding="md" align="center">
          <Col padding="top-md">
            <Text caption>
              <UniverseLink
                id="footer-terms-and-notice-link"
                href="https://conseils-travaux.quotatis.fr/cgu-avis-et-notation-2/"
                color="white"
                margin="horizontal-xs"
              >
                {translate('footer.corporate.terms_and_notice')}
              </UniverseLink>
              -
              <UniverseLink
                id="footer-terms-of-sale-link"
                href="https://conseils-travaux.quotatis.fr/cgu/"
                color="white"
                margin="horizontal-xs"
              >
                {translate('footer.corporate.terms_of_sale')}
              </UniverseLink>
              -
              <UniverseLink
                id="footer-personal-data-link"
                href="https://conseils-travaux.quotatis.fr/charte-de-confidentialite-donnees/"
                color="white"
                margin="horizontal-xs"
              >
                {translate('footer.corporate.personal_data')}
              </UniverseLink>
              -
              <UniverseLink
                id="footer-legal-notice-link"
                href="https://conseils-travaux.quotatis.fr/mentions-legales/"
                color="white"
                margin="horizontal-xs"
              >
                {translate('footer.corporate.legal_notice')}
              </UniverseLink>
              -
              <UniverseLink
                id="footer-quality-charter-link"
                href="https://lecoindespros.quotatis.fr/charte-de-qualite/"
                color="white"
                margin="horizontal-xs"
              >
                {translate('footer.corporate.quality_charter')}
              </UniverseLink>
            </Text>
          </Col>
        </Row>
      </Container>
    </Footer>
  )
}

FooterSection.propTypes = {
  translate: PropTypes.func,
}

export default injectTranslate(FooterSection)
